import React from 'react';
import { LayoutContent, LayoutContentHeader } from '@pinwheel/origami';
var TitleFrame = function (_a) {
    var title = _a.title, subtitle = _a.subtitle, children = _a.children, testId = _a["data-testid"];
    return (React.createElement(LayoutContent, { "data-testid": testId },
        React.createElement(LayoutContentHeader, { title: title, subtitle: subtitle }),
        children));
};
export default TitleFrame;
